import React from 'react';
//Functional Component 
class ReservePage extends React.Component{
    
    render()
    {
        return (
            <div className="App">
                <body className = "profile-body" style={{color:"white"}}>
                    <h1>Thanks for choosing Auxillia!</h1>
                    <h3>Your Zoom Link should have been sent to your email.</h3>
                    <h3>If you have any questions please email us at jeffauxillium@gmail.com</h3>
                {/* <div class="dropdown">
                    <button class="dropbtn">Select Class</button>
                    <div class="dropdown-content">
                        <a href="#">Link 1</a>
                        <a href="#">Link 2</a>
                        <a href="#">Link 3</a>
                    </div>
                </div> */}
                    {/* <div class = "wrapperP">
                        <div class = "left">
                            <img src = "profilephoto.png" alt =  "user Photo" width = "240" ></img>
                            <h4>Ajit Jain</h4>
                            <p>A&M TA</p>
                        </div>
                        <div class = "right">
                            <div class = "info">
                                <h3>Ajit Jain</h3>
                                <div class = "info_data">
                                    <div class = "data">
                                        <h4>Email</h4>
                                        <p>Ajit24@tamu.edu</p>
                                    </div>
                                    <div class = "data">
                                        <h4>Phone</h4>
                                        <p>999-9999-9999</p>
                                    </div>
                                    <div class = "data">
                                        <h4>Class Year</h4>
                                        <p>2020</p>
                                    </div>
                                    <div class = "data">
                                        <h4>Hourly Rate</h4>
                                        <p>$10</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div> */}
                    
                </body>
            </div>
        );
    }
  }



export default ReservePage;